<template>
  <div v-if="summary" class="deal-health-bar mb-4">
    <div class="d-flex flex-wrap align-center">
      <v-chip
        v-if="summary.counts.sales_orders"
        x-small
        class="mr-2 mb-1 deal-health-bar__chip deal-health-bar__chip--sales-order"
      >
        {{ summary.counts.sales_orders }} SO
      </v-chip>
      <v-chip
        v-if="summary.counts.purchase_orders"
        x-small
        class="mr-2 mb-1 deal-health-bar__chip deal-health-bar__chip--purchase-order"
      >
        {{ summary.counts.purchase_orders }} PO
      </v-chip>
      <v-chip
        v-if="summary.counts.transport_orders"
        x-small
        class="mr-2 mb-1 deal-health-bar__chip deal-health-bar__chip--transport"
      >
        {{ summary.counts.transport_orders }} TO
      </v-chip>
      <v-chip
        v-if="summary.counts.receipts"
        x-small
        class="mr-2 mb-1 deal-health-bar__chip deal-health-bar__chip--receipt"
      >
        {{ summary.counts.receipts }} {{ $t("DEALS.VIEW.RECEIPTS_SHORT") }}
      </v-chip>
      <v-chip
        v-if="summary.counts.deliveries"
        x-small
        class="mr-2 mb-1 deal-health-bar__chip deal-health-bar__chip--delivery"
      >
        {{ summary.counts.deliveries }} {{ $t("DEALS.VIEW.DELIVERIES_SHORT") }}
      </v-chip>
      <v-chip
        v-if="summary.pending_actions"
        x-small
        color="orange lighten-4"
        text-color="orange darken-3"
        class="mr-2 mb-1"
      >
        {{ summary.pending_actions }} {{ $t("DEALS.VIEW.PENDING_ACTIONS") }}
      </v-chip>
      <v-chip
        v-if="summary.total_files"
        x-small
        outlined
        class="mb-1"
      >
        {{ summary.total_files }} {{ $t("DEALS.VIEW.FILES") }}
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: "DealHealthBar",
  props: {
    summary: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped>
.deal-health-bar__chip {
  font-weight: 600;
}

.deal-health-bar__chip--purchase-order {
  background: rgba(57, 73, 171, 0.12) !important;
  color: #3949ab !important;
}

.deal-health-bar__chip--sales-order {
  background: rgba(0, 137, 123, 0.12) !important;
  color: #00897b !important;
}

.deal-health-bar__chip--receipt {
  background: rgba(245, 124, 0, 0.12) !important;
  color: #f57c00 !important;
}

.deal-health-bar__chip--delivery {
  background: rgba(123, 31, 162, 0.12) !important;
  color: #7b1fa2 !important;
}

.deal-health-bar__chip--transport {
  background: rgba(2, 136, 209, 0.12) !important;
  color: #0288d1 !important;
}
</style>
